import { createAsyncThunk } from "@reduxjs/toolkit";
import { UsersAPI } from "api/api/usersApi/usersApi";
import axios from "axios";
import { PutUsersSetLangParams, PutUsersSetLangResponse } from "api/api/usersApi/types";

export const putUsersLang = createAsyncThunk<
  PutUsersSetLangResponse,
  PutUsersSetLangParams
>(
  "users/putUsersLang",
  async (params, { rejectWithValue }) => {
    try {
      const response = await UsersAPI.putUsersLanguage(params);
      return response.data;
    } catch (error: unknown) {
      if (axios.isAxiosError(error)) {
        console.error("Error while setting language", error.response?.data);
        return rejectWithValue(error.response?.data || "Unknown error");
      }
      else {
        console.error("Error while setting language", error);
        return rejectWithValue(
          "Что-то пошло не так... Попробуйте обновить страницу"
        );
      }
    }
  })